module.exports = __webpack_public_path__ + "static/media/tyst.960b579e.mp3";